import { PublicKey, type PublicKeyWire } from "./public-key.js";

export type AccountId = PublicKey;
export const AccountId = PublicKey;
export type AccountIdWire = PublicKeyWire;
